<template>
<div id="login-panel" class="container">
	<div class="row">
		<div class="col-sm-4">
			<img class="logo-image default" src="/static/img/authlogics-logo-full.png"/>
		</div>
		<div class="col-sm-4">
		</div>
		<div class="col-sm-4">
		</div>
	</div>
  <div class="row">
    <div class="col-sm-4">
    </div>
	<div class="col-sm-4">
		<form id="login" data-toggle="validator" autocomplete="off" v-on:submit.prevent="submitForm">                   

			<error :error="error"></error>	

			<div v-if="message && !error" role="alert" class="alert alert-custom-high mb-4"><span class="icon icon-warning mr-2"></span> 
				{{message}}
			</div>

			<div class="m-t form-group required">
				<label for="username" class="control-label required">Username</label>
				<input type="text" id="username" name="username" class="form-control" placeholder="Username" required autofocus v-model.lazy="username">
				<div class="help-block with-errors"></div>
			</div>
			<div class="form-group required">
				<label id="password-text" for="password" class="control-label required">Password</label>
				<input type="password" id="password" name="password" class="form-control" placeholder="Password" required v-model.lazy="password">
				<div class="help-block with-errors"></div>
			</div>                        
			<div class="text-center m-t">
				<button class="btn btn-outline-primary action-button" type="submit">Sign in</button>
			</div>
		</form>
	</div>
    <div class="col-sm-4"></div>
  </div>
</div>    
</template>

<script>
	import Error from './Error'

	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'LoginPanel',
		components: {Error},
		props: ['message'],
		data() {
			return {
				username: '',
				password: '',
				error: null
			}
		},
		methods: {
			async submitForm() {
						
				try
				{
					var response = await api.post('token', {userName: this.username, password: this.password});	

					//Ensure the user details are loaded
					store.commit('login', response.data);

					await store.dispatch('getUserAsync');

					store.dispatch('getDomainsAsync');
					store.dispatch('getEmailsAsync');
					store.dispatch('getAuditsAsync');
					store.dispatch('getSourcesAsync');

					//Get and clear any login redirect
					let redirect = store.state.redirect;
					store.commit('clearRedirect');

					//Determine if there are any redirects
					if (redirect) {
						
						if (redirect.meta && redirect.meta.redirectTo) {
							router.push({name: redirect.meta.redirectTo});
							return;
						}
						
						router.push({name: redirect.name});
						return;
					}

					//Else redirect to domains as the home page for now
					router.push({name: 'domains'});  
				}
				catch(err) {
					if (err.response && err.response.status === 401) err.response.data = "User or password was incorrect."					
					this.error = err;
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/LoginPanel.vue